import { render } from "./ListText.vue?vue&type=template&id=4701b6e8&scoped=true&ts=true"
import script from "./ListText.vue?vue&type=script&lang=ts"
export * from "./ListText.vue?vue&type=script&lang=ts"

import "./ListText.vue?vue&type=style&index=0&id=4701b6e8&scoped=true&lang=css"

import exportComponent from "../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4701b6e8"]])

export default __exports__